import { useTranslation } from 'react-i18next'

// The sign-in split's brand column: the blue-tinted ground with the line set
// straight on it like a deck cover. No card: glass belongs to the sidebar only,
// and the logo already heads the form.
//
// Deliberately carries no `position` and no `z-index`: FloatingLanguageToggle
// is fixed z-50 and sits over this panel at lg+, and a stacking context here
// would swallow the click that e2e/smoke/locale.spec.ts performs.
export default function AuthBrandPanel() {
  const { t } = useTranslation('admin')
  return (
    <div className="auth-ground flex h-full items-end p-12 xl:p-16">
      <p className="max-w-md font-heading text-display text-foreground">{t('login.panelLine')}</p>
    </div>
  )
}
